var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconJo = function SvgIconJo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.304 7.826h15.95C21.557 3.256 17.158 0 11.998 0a11.96 11.96 0 0 0-8.484 3.515z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M7.304 16.175h15.95C21.557 20.745 17.158 24 11.998 24a11.96 11.96 0 0 1-8.484-3.515z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M3.515 3.514c-4.687 4.686-4.687 12.284 0 16.97L12 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "m4.763 9.392.658 1.377 1.488-.344-.667 1.374 1.196.948-1.489.336.004 1.526-1.19-.955-1.191.955.004-1.526-1.49-.336 1.197-.948-.666-1.374 1.487.344z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconJo;